import { render, staticRenderFns } from "./StudentStepperPanel.vue?vue&type=template&id=b2feba8c&scoped=true"
import script from "./StudentStepperPanel.vue?vue&type=script&lang=js"
export * from "./StudentStepperPanel.vue?vue&type=script&lang=js"
import style0 from "./StudentStepperPanel.vue?vue&type=style&index=0&id=b2feba8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2feba8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VForm,VLayout})
